var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Person"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M11.8362 9.33329C12.6642 9.33329 13.3354 10.0045 13.3354 10.8325V11.4448C13.3354 11.8271 13.2159 12.1998 12.9937 12.5108C11.9631 13.9529 10.2802 14.6674 8.00004 14.6674C5.71939 14.6674 4.03742 13.9526 3.00931 12.5097C2.788 12.1991 2.66907 11.8272 2.66907 11.4459V10.8325C2.66907 10.0045 3.34031 9.33329 4.16832 9.33329H11.8362ZM8.00004 1.33643C9.84099 1.33643 11.3334 2.82881 11.3334 4.66976C11.3334 6.51071 9.84099 8.00309 8.00004 8.00309C6.15909 8.00309 4.66671 6.51071 4.66671 4.66976C4.66671 2.82881 6.15909 1.33643 8.00004 1.33643Z",
    fill: "#9B9DAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.0da860167e60e5a59677f35a20aa022b.svg";
export { ForwardRef as ReactComponent };